/**
 * Canvassing Mobile Service
 * API calls for mobile canvassing features (technician + franchisee use)
 */
import { crudOperations } from './api';

const canvassingMobileService = {
  // === LEADS ===

  async getNextNewLead(categoryId = null, lat = null, lng = null) {
    try {
      const params = {};
      if (categoryId) params.categoryId = categoryId;
      if (lat != null && lng != null) {
        params.lat = lat;
        params.lng = lng;
      }
      const response = await crudOperations.get('/canvassing-mobile/leads/next-new', params);
      return response.data;
    } catch (error) {
      console.error('Error fetching next new lead:', error);
      throw error;
    }
  },

  async getRecentLeads(page = 1, limit = 20) {
    try {
      const response = await crudOperations.get('/canvassing-mobile/leads/recent', { page, limit });
      return response.data;
    } catch (error) {
      console.error('Error fetching recent leads:', error);
      throw error;
    }
  },

  async getLeads(params = {}) {
    try {
      const response = await crudOperations.get('/canvassing-mobile/leads', params);
      return response.data;
    } catch (error) {
      console.error('Error fetching canvassing leads:', error);
      throw error;
    }
  },

  async getDailyList(batchSize = 20) {
    try {
      const response = await crudOperations.get('/canvassing-mobile/leads/daily-list', { batch: batchSize });
      return response.data;
    } catch (error) {
      console.error('Error fetching daily list:', error);
      throw error;
    }
  },

  async getLead(leadId) {
    try {
      const response = await crudOperations.get(`/canvassing-mobile/leads/${leadId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching lead detail:', error);
      throw error;
    }
  },

  async getStats() {
    try {
      const response = await crudOperations.get('/canvassing-mobile/leads/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching canvassing stats:', error);
      throw error;
    }
  },

  async getTowns() {
    try {
      const response = await crudOperations.get('/canvassing-mobile/leads/towns');
      return response.data;
    } catch (error) {
      console.error('Error fetching towns:', error);
      throw error;
    }
  },

  async getCategories() {
    try {
      const response = await crudOperations.get('/canvassing-mobile/leads/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  // === NOTES ===

  async getLeadNotes(leadId) {
    try {
      const response = await crudOperations.get(`/canvassing-mobile/leads/${leadId}/notes`);
      return response.data;
    } catch (error) {
      console.error('Error fetching lead notes:', error);
      throw error;
    }
  },

  async createNote(leadId, noteText) {
    try {
      const response = await crudOperations.post(`/canvassing-mobile/leads/${leadId}/notes`, { note_text: noteText });
      return response.data;
    } catch (error) {
      console.error('Error creating note:', error);
      throw error;
    }
  },

  async updateNote(noteId, noteText) {
    try {
      const response = await crudOperations.put(`/canvassing-mobile/leads/notes/${noteId}`, { note_text: noteText });
      return response.data;
    } catch (error) {
      console.error('Error updating note:', error);
      throw error;
    }
  },

  // === STATUS ===

  async updateStatus(leadId, statusData) {
    try {
      const response = await crudOperations.put(`/canvassing-mobile/status/${leadId}`, statusData);
      return response.data;
    } catch (error) {
      console.error('Error updating lead status:', error);
      throw error;
    }
  },

  async addCallLog(leadId, callData) {
    try {
      const response = await crudOperations.post(`/canvassing-mobile/status/${leadId}/call-log`, callData);
      return response.data;
    } catch (error) {
      console.error('Error adding call log:', error);
      throw error;
    }
  },

  // === CALLBACKS ===

  async getDueCallbacks(filter = 'all') {
    try {
      const response = await crudOperations.get('/canvassing-mobile/callbacks/due', { filter });
      return response.data;
    } catch (error) {
      console.error('Error fetching due callbacks:', error);
      throw error;
    }
  },

  async scheduleCallback(callbackData) {
    try {
      const response = await crudOperations.post('/canvassing-mobile/callbacks', callbackData);
      return response.data;
    } catch (error) {
      console.error('Error scheduling callback:', error);
      throw error;
    }
  },

  async updateCallback(callbackId, callbackData) {
    try {
      const response = await crudOperations.put(`/canvassing-mobile/callbacks/${callbackId}`, callbackData);
      return response.data;
    } catch (error) {
      console.error('Error updating callback:', error);
      throw error;
    }
  },

  async completeCallback(callbackId) {
    try {
      const response = await crudOperations.put(`/canvassing-mobile/callbacks/${callbackId}/complete`);
      return response.data;
    } catch (error) {
      console.error('Error completing callback:', error);
      throw error;
    }
  },

  async cancelCallback(callbackId) {
    try {
      const response = await crudOperations.delete(`/canvassing-mobile/callbacks/${callbackId}`);
      return response.data;
    } catch (error) {
      console.error('Error cancelling callback:', error);
      throw error;
    }
  },

  // === CONVERSION ===

  async convertLead(leadId, conversionData) {
    try {
      const response = await crudOperations.post(`/canvassing-mobile/convert/${leadId}`, conversionData);
      return response.data;
    } catch (error) {
      console.error('Error converting lead:', error);
      throw error;
    }
  }
};

export default canvassingMobileService;
